export default __webpack_public_path__ + "static/media/icon-warning-text.3faaf03d.svg";